import React from 'react';
import ReactDOM from 'react-dom/client';
import ConfiguratorPage from './components/ConfiguratorPage';
import { PostHogProvider } from 'posthog-js/react';

const root =  ReactDOM.createRoot(document.getElementById('react-root'));
root.render(
  <React.StrictMode>
      <PostHogProvider
          apiKey={process.env.REACT_APP_POSTHOG_KEY}
          options={{
              api_host: process.env.REACT_APP_POSTHOG_HOST,
              capture_exceptions: true,
              debug: process.env.NODE_ENV === 'development',
          }}
      >
          <ConfiguratorPage/>
      </PostHogProvider>
  </React.StrictMode>
);